import { render, staticRenderFns } from "./ShareApp.vue?vue&type=template&id=10132f46&scoped=true&"
import script from "./ShareApp.vue?vue&type=script&lang=js&"
export * from "./ShareApp.vue?vue&type=script&lang=js&"
import style0 from "./ShareApp.vue?vue&type=style&index=0&id=10132f46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10132f46",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VIcon,VRow})
